import React, { useContext } from "react";
import { makeStyles } from "tss-react/mui";
import { LocalizedText } from "../../../components/i18n/LocalizedText.js";
import { LinkText } from "../../../components/link/LinkText.js";
import "../../../components/link/LinkButton.js";
import "../../../components/modal/BulkModalContent.js";
import "../../../components/modal/BulkModalProvider.js";
import "@mui/material";
import "../../../components/modal/ModalButtons.js";
import "../../../components/modal/Modal.style.js";
import "../../../components/button/Buttons.js";
import "../../../components/button/EditButton.js";
import "../../../components/error/ErrorAccordion.js";
import "../../../components/error/ErrorDetails.js";
import "../../../components/error/localize.js";
import "../../../components/error/ErrorModal.js";
import "react-intl";
import "../../../components/error/GlobalServerErrorMessage.js";
import "../../../components/icons/Icon.js";
import "../../../components/icons/ExpandMoreIcon.js";
import "@opentelemetry/api";
import "../../../otel/TraceProvider.js";
import "react-error-boundary";
import "rxjs/operators";
import "@opentelemetry/context-zone";
import "@opentelemetry/exporter-trace-otlp-http";
import "@opentelemetry/instrumentation";
import "@opentelemetry/instrumentation-document-load";
import "@opentelemetry/instrumentation-xml-http-request";
import "@opentelemetry/resources";
import "@opentelemetry/sdk-trace-web";
import "@opentelemetry/semantic-conventions";
import { ModalContext } from "../../../components/modal/types.js";
import "../../../components/modal/ActionConfirmationModal.js";
import { PlayerGlobalSettings } from "./PlayerGlobalSettings.js";
const useStyles = makeStyles()(() => ({
  disabled: {
    cursor: "default"
  }
}));
function PlayerGlobalSettingsLink({
  uid,
  disabled,
  label,
  modalTitle,
  entityType,
  mode = "all"
}) {
  const { openModal } = useContext(ModalContext);
  const { classes, cx } = useStyles();
  function handleClick() {
    if (!disabled && uid) {
      openModal({
        title: /* @__PURE__ */ React.createElement(LocalizedText, { label: modalTitle }),
        body: /* @__PURE__ */ React.createElement(PlayerGlobalSettings, { uid, entityType, mode }),
        styleParams: {
          maxWidth: mode === "all" ? "lg" : "sm"
        }
      });
    }
  }
  return /* @__PURE__ */ React.createElement(LinkText, { title: label, onClick: handleClick, className: cx((disabled || !uid) && classes.disabled) });
}
export {
  PlayerGlobalSettingsLink
};
//# sourceMappingURL=PlayerGlobalSettingsLink.js.map
